import Box from "@mui/material/Box";
import { memo, PropsWithChildren } from "react";
import { TradingAccount } from "../../../proto/generated/trading-bridge";
import { useSelector } from "react-redux";
import { selectTradingAccounts } from "../../../selectors/user";

const BrokerAuthRedirectContainer: React.FC<PropsWithChildren> = ({children}) => {
    const tradingAccounts: TradingAccount[] = useSelector(selectTradingAccounts);

    return <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'center',
                alignContent: 'center'
            }}
        >
            <p style={{ fontSize: '24px', color: 'black', paddingTop: '24px' }}>{'Logging in'}</p>
            {tradingAccounts ? children : null}
        </Box>;
};

export default memo(BrokerAuthRedirectContainer);